import { createStyles } from '@material-ui/core/styles';

export default createStyles({
  widgetContainer: {
    flexGrow: 1,
    padding: '10px',
    maxWidth: '100%',
    background: '#fff'
  },
  root: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    boxShadow: 'none',
    marginBottom: '0 !important',
  },
  heading: {
    padding: '10px',
    marginBottom: '10px',
    backgroundColor: '#eeeeee',
    borderBottom: '1px solid #ddd',
    fontSize: '14px',
    fontWeight: 'bold',
    lineHeight: '34px',
    textTransform: 'uppercase'
  },
  alertsContainer: {
    'flex': 1,
    'overflowY': 'auto',
    '& > div:last-child': {
      marginBottom: '0 !important',
    }
  },
  alertItem: {
    'textAlign': 'center',
    'marginBottom': '12px !important',
    'padding': '12px',
    'transition': 'box-shadow 0.3s',
    '&:hover': {
      boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
    }
  },
  alertTitle: {
    fontWeight: 600,
    color: '#fff',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    columnGap: '6px',
  },
  alertMessage: {
    color: '#666',
    marginBottom: '8px'
  },
  alertLink: {
    'cursor': 'pointer',
    'color': '#fff',
    'fontWeight': 600,
    'textDecoration': 'underline',
    '&:hover': {
      textDecoration: 'none'
    }
  },
  alertMessageDiv: {
    display: 'flex',
  },
  alertIconWarning: {
    color: '#000',
  },
});
